export enum StickyFormats {
	FLYING = 'flying',
	BANNER = 'banner'
}
